const About = () => {
  return (
    <section className="section">
      <h2>About Page</h2>
    </section>
  );
};
export default About;
